class ScHeaderMenu extends HTMLElement {
  connectedCallback() {
    this.wrapper = this.querySelector(".sc-menu-wrapper");
    this.toggleButtons = this.querySelectorAll("[sc-toggle-menu]");
    this.submenuLinks = this.querySelectorAll("[toggle-submenu]");

    this.toggleButtons.forEach((el) => {
      el.addEventListener("click", () => {
        if (this.wrapper) {
          this.wrapper.classList.toggle("is-open");
        }
      });
    });

    this.submenuLinks.forEach((el) => {
      el.addEventListener("click", (e) => {
        e.preventDefault();
        const linkContainer = el.closest(".sc-menu-link");
        const sub = linkContainer.nextElementSibling;

        if (!sub || !sub.classList.contains("sc-menu-sublinks")) return;

        const isOpen = sub.dataset.sublinkState === "1";

        if(isOpen) {
          sub.dataset.sublinkState = "0";
          sub.classList.remove("menu-sublinks-open");
          sub.style.height = "0px";
        } else {
          sub.dataset.sublinkState = "1";
          sub.classList.add("menu-sublinks-open");
          sub.style.height = `${sub.scrollHeight}px`;
        }
      });
    });
  }
}

customElements.define("sc-header-menu", ScHeaderMenu)

/* SC FAQ Toggle Button */

class QuestionToggle extends HTMLElement {
  constructor() {
    super();
    this.innerHTML = `
      <span class="sc-icon plus"></span>
      <span class="sc-icon minus"></span>
    `;
  }

  connectedCallback() {
    this.faqBlock = this.closest(".faq-block");
    this.faqBlock.addEventListener("click", () => this.toggle());
  }

  toggle() {
    const isOpen = this.classList.contains("open");
    this.classList.toggle("open", !isOpen);
    this.faqBlock.classList.toggle("active", !isOpen);
  }
}

customElements.define("question-toggle", QuestionToggle);


/* SC Product Page */
class QuantityButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.handleClick);
  }

  connectedCallback() {
    this.input = this.closest('.product-quantity-quantity').querySelector('.quantity-input');
  }

  handleClick() {
    const type = this.getAttribute('type');
    let currentValue = parseInt(this.input.value) || 1;
    const maxQuantity = parseInt(this.input.getAttribute('max')) || Infinity;

    if (type === 'plus' && currentValue < maxQuantity) {
      this.input.value = currentValue + 1;
    } else if (type === 'minus' && currentValue > 1) {
      this.input.value = currentValue - 1;
    }

    this.input.dispatchEvent(new Event('change'));
  }
}

class AddToCartButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.addToCart);
  }

  connectedCallback() {
    this.quantityInput = this.closest('.sc-product-mash').querySelector('.quantity-input');
    this.successText = this.getAttribute('data-success');
    this.originalText = this.querySelector('span').textContent;
  }

  async addToCart() {
    if (!this.quantityInput) {
      console.error('Quantity input not found');
      return;
    }

    this.classList.add('sc-load');
    const variantId = this.getAttribute('data-variant-id');
    const quantity = parseInt(this.quantityInput.value) || 1;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity,
        }),
      });

      if (!response.ok) throw new Error('Failed to add to cart');

      this.querySelector('span').textContent = this.successText;
      setTimeout(() => {
        this.querySelector('span').textContent = this.originalText;
      }, 8000);
    } catch (error) {
      console.error('Error adding to cart:', error);
      this.querySelector('span').textContent = 'Error';
      setTimeout(() => {
        this.querySelector('span').textContent = this.originalText;
      }, 2000);
    } finally {
      this.classList.remove('sc-load');
    }
  }
}

customElements.define('button-quantity', QuantityButton);
customElements.define('button-add-cart', AddToCartButton);

class HideOpenFAQ extends HTMLElement {
  constructor() {
    super();
    this.innerHTML = `
      <svg id="Pfeil" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
        <path id="Pfad_37" data-name="Pfad 37" d="M6214.8,1384.942l4.8-4.8,4.8,4.8" transform="translate(-6204.304 -1368.442)" fill="none" stroke="#2e2c27" stroke-width="2"/>
      </svg>
    `;
  }

  connectedCallback() {
    this.faqBlock = this.closest(".faq-block");
    this.faqBlock.addEventListener("click", () => this.toggle());
  }

  toggle() {
    const isOpen = this.classList.contains("open");
    this.classList.toggle("open", !isOpen);
    this.faqBlock.classList.toggle("active", !isOpen);
  }
}

customElements.define("faq-toggle", HideOpenFAQ);

class SizeChartModal extends HTMLElement {
    constructor() {
      super();
      this.attachShadow({ mode: 'open' });
    }

    connectedCallback() {
      const linkText = this.getAttribute('link-text') || 'Größentabelle';
      const pageContent = this.innerHTML;

      this.shadowRoot.innerHTML = `
        <style>
          .modal {
            position: fixed;
            top: 0; left: 0;
            width: 100%; height: 100%;
            background: rgba(0,0,0,0.5);
            display: none;
            align-items: center;
            justify-content: center;
            z-index: 9999;
          }
          .modal.active {
            display: flex;
          }
          .modal-content {
            background: #fff;
            padding: 2rem;
            max-width: 700px;
            width: 90%;
            max-height: 90vh;
            overflow-y: auto;
            border-radius: 8px;
            position: relative;
          }
          .close {
            position: absolute;
            top: 1rem; right: 1rem;
            cursor: pointer;
            font-size: 1.5rem;
          }
          a.link {
            cursor: pointer;
            text-decoration: underline;
            color: inherit;
          }
        </style>

        <a class="link">${linkText}</a>
        <div class="modal">
          <div class="modal-content">
            <span class="close">&times;</span>
            <div class="content">${pageContent}</div>
          </div>
        </div>
      `;

      const modal = this.shadowRoot.querySelector('.modal');
      const link = this.shadowRoot.querySelector('.link');
      const close = this.shadowRoot.querySelector('.close');

      link.addEventListener('click', e => {
        e.preventDefault();
        modal.classList.add('active');
      });

      close.addEventListener('click', () => modal.classList.remove('active'));
      modal.addEventListener('click', (e) => {
        if (e.target === modal) modal.classList.remove('active');
      });
    }
  }

  customElements.define('size-chart-modal', SizeChartModal);